export const routes = {
  REPORT: `/report`,
};
